<div class="radio-button-renderer-wrapper"> 
  <mat-radio-button (click)="onRadioClick($event)" class="nv-mat-radio-button"></mat-radio-button>
  <div class="icon-space-filler" *ngIf="!icon" ></div>  
</div>